<template>
  <div class="max-w-[75%] flex flex-col items-end relative message-bubble-container">
    <div class="flex items-start gap-8">
      <MessageBubbleActions :message-body="body" :is-visible="showActions" />
      <Card :custom-classes="bubbleClasses" :aria-label="ariaLabel">
        <MessageBubbleBody :body="body" />
      </Card>
    </div>
    <MessageBubbleTimestamp :timestamp="timestamp" :is-outgoing="true" :read="read" :message-status="messageStatus" />
  </div>
</template>

<script lang="ts">
import type { PropType } from 'vue';
import type { MessageStatus } from '@/apps/messages/types';
import Card from '@/components/card/Card.vue';
import MessageBubbleBody from './MessageBubbleBody.vue';
import MessageBubbleTimestamp from './MessageBubbleTimestamp.vue';
import MessageBubbleActions from './MessageBubbleActions.vue';

const OUTGOING_BUBBLE_CLASSES = 'bg-safety-contrast text-white inline-block max-w-full px-12 py-10';

export default {
  name: 'MessageBubbleOutgoing',
  components: {
    Card,
    MessageBubbleBody,
    MessageBubbleTimestamp,
    MessageBubbleActions,
  },
  props: {
    body: {
      type: String,
      default: '',
    },
    timestamp: {
      type: String,
      default: '',
    },
    ariaLabel: {
      type: String,
      required: true,
    },
    read: {
      type: Boolean,
      default: false,
    },
    messageStatus: {
      type: String as PropType<MessageStatus>,
      default: 'sent',
    },
    showActions: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    bubbleClasses(): string {
      return OUTGOING_BUBBLE_CLASSES;
    },
  },
};
</script>
